"use strict";

var km = require('keymirror');

module.exports = km({
  SERVER_DATA_LOADING: null,
  SERVER_DATA_LOADED: null,
  SERVER_DATA_READY: null,
  QUOTE_DATA_CHANGED: null,
  USER_LOGIN_ANSWER: null,
  USER_REGISTER_ANSWER: null,
  QUOTE_SAVED: null,
  QUOTE_BEFORE_SAVE: null,
  RESET_PASSWORD_ANSWER: null,
  HIDE_HELP_BALLOON: null,
  SHOW_SUMMARY: null,
  SCHEDULE_COMPLETED: null,
  SHOW_NUMERIC_KBD: null,
  RECEIVED_JOB_DATA: null,
  /**
   * Use to generate an event when some kind of overlay layer is clicked.
   * Servers the purpose to catch clicks outside of popup item, such as on screen keyboards
   */
  OVERLAY_CLICK: null,
  CURRENT_NOTE_CHANGED: null,
  DOCUMENTS_CHANGED: null,

  /**
   * Events used to communicate with the Kitchen Visualizer Frame
   */
  UPDATE_USER_INFO: null,
  UPDATE_KV_FEATURES: null,
  IFRAME_CAN_RECIEVE_DATA: null,
  QUOTE_DELETED: null
});





// WEBPACK FOOTER //
// ./src/actionTypes.js